// extracted by mini-css-extract-plugin
module.exports = {"moreStoriesBtnWrap":"YJxNP","moreStoriesBtnL2Wrap":"gquvE","redBtn":"hOCUi","col_3":"VdeHw","col":"tBPdd"};